import type { ListaItens, SeletorItem } from '@Lar21/imaginii-web-components/vue'
import type { FiltrosCatalogoUsuario, OpcaoUsuario, SelecaoCatalogoUsuario } from '../catalogo-usuario.tipos'

export const CHAVE_I18N_CATALOGO_USUARIO = 'srcNext.governanca.catalogoUsuario'

export const filtrarOpcoesUsuario = (
  opcoes: readonly OpcaoUsuario[],
  filtros?: FiltrosCatalogoUsuario,
  predicado?: (opcao: OpcaoUsuario) => boolean,
): readonly OpcaoUsuario[] => {
  if ((!filtros || Object.keys(filtros).length === 0) && !predicado) return opcoes
  return opcoes.filter(opcao => (filtros?.roleGroup?.id === undefined || filtros.roleGroup.id.some(id => opcao.roleGroup?.id === id))
    && (filtros?.roleGroup?.kind === undefined || filtros.roleGroup.kind.some(kind => opcao.roleGroup?.kind === kind))
    && (!predicado || predicado(opcao)))
}

const item = (opcao: OpcaoUsuario): SeletorItem => ({
  chave: opcao.id,
  valor: opcao.name,
  ...(typeof opcao.roleGroup?.name === 'string' && opcao.roleGroup.name.trim() ? { legenda: opcao.roleGroup.name } : {}),
})
const listaSelecionada = (
  valor: SelecaoCatalogoUsuario,
  multipla: boolean,
): readonly OpcaoUsuario[] => {
  if (valor === null) return []
  if (!Array.isArray(valor)) return [valor as OpcaoUsuario]
  if (multipla) return valor as readonly OpcaoUsuario[]
  const primeira = valor[0] as OpcaoUsuario | undefined
  return primeira ? [primeira] : []
}
export const criarEstadoSeletorCatalogoUsuario = (
  opcoes: readonly OpcaoUsuario[],
  valor: SelecaoCatalogoUsuario,
  multipla: boolean,
): ListaItens => {
  const carregados = opcoes.filter(opcao => typeof opcao.id === 'string' && Boolean(opcao.id.trim()) && typeof opcao.name === 'string' && Boolean(opcao.name.trim())).map(item)
  const porId = new Map(carregados.map((i) => [String(i.chave), i]))
  return {
    carregados,
    selecionados: listaSelecionada(valor, multipla).flatMap((opcao) => {
      const selecionado = porId.get(opcao.id)
      return selecionado ? [selecionado] : []
    }),
  }
}
export const extrairValorDoSeletorCatalogoUsuario = (
  estado: ListaItens,
  opcoes: readonly OpcaoUsuario[],
  multipla: boolean,
): SelecaoCatalogoUsuario => {
  const porId = new Map(opcoes.map((opcao) => [opcao.id, opcao]))
  const resultado = [...new Set(estado.selecionados.map(({ chave }) => String(chave)))]
    .flatMap((id) => {
      const opcao = porId.get(id)
      return opcao ? [opcao] : []
    })
  return multipla ? resultado : (resultado[0] ?? null)
}
type Traduzir = (chave: string) => string
export const criarPropriedadesPontotelSeletorUsuario = ({
  traduzir, label, placeholder, erro,
}: Readonly<{ traduzir: Traduzir, label?: string, placeholder?: string, erro: string | null }>) => ({
  tamanho: 'M' as const, largura: '100%', tamanhoPagina: 20,
  pesquisavel: true, recarregarTodos: true,
  label: label ?? traduzir(`${CHAVE_I18N_CATALOGO_USUARIO}.label`),
  placeholder: placeholder ?? traduzir(`${CHAVE_I18N_CATALOGO_USUARIO}.placeholder`),
  erro,
  traducaoNenhumResultado: traduzir(`${CHAVE_I18N_CATALOGO_USUARIO}.nenhumResultado`),
  traducaoSelecionado: traduzir(`${CHAVE_I18N_CATALOGO_USUARIO}.selecionado`),
  traducaoSelecionadosPlural: traduzir(`${CHAVE_I18N_CATALOGO_USUARIO}.selecionados`),
  traducaoRecarregarTodos: traduzir(`${CHAVE_I18N_CATALOGO_USUARIO}.recarregar`),
  traducaoRecarregado: traduzir(`${CHAVE_I18N_CATALOGO_USUARIO}.recarregado`),
})
